"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var ExportedPriceHistory_1 = require("../../../price-list/model/ExportedPriceHistory"); // tslint:disable:max-classes-per-file

/**
 * <p>Data transfer object (persisted) which encapsulates metadata and executive data for termination of sellout prices. Instance of this
 * entity are created after successful upload. The source data is taken from {@link SelloutReleaseItem release item} and associated
 * {@link SelloutRelease release}.</p>
 *
 * <p>Instances of this entity are propagated to {@link SelloutReleaseItem items} only when the entire {@link SelloutTermination process}
 * is confirmed by the user. After the process is confirmed, user cannot edit any attribute.</p>
 *
 * <p>The information loaded from items could change before the confirmation of process by user. Thus they must be validated before each and
 * every confirmation of termination process. All data from {@link SelloutReleaseItem origin items} is loaded again and key attributes
 * should be checked for changes (in case of conflict, confirmation of termination process cannot be executed).</p>
 *
 * @author JMe
 */


var SelloutTerminationItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTerminationItem, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Identification of the record.
   * @param terminationId Corresponds to {@link SelloutTermination.id}.
   * @param rId Corresponds to {@link SelloutRelease.id}.
   * @param rName Corresponds to {@link SelloutRelease.name}.
   * @param pListType Corresponds to {@link SelloutRelease.priceListType}.
   * @param workflowType Corresponds to {@link SelloutRelease.workflowType}, but modelled as string to be more flexible.
   * @param iId Corresponds to associated {@link SelloutReleaseItem.id}.
   * @param pExtId Corresponds to {@link Product.externalId}.
   * @param pId Corresponds to {@link Product.id}.
   * @param pName Corresponds to {@link SelloutReleaseItem.productName}, should be the same as {@link Product.name}, but value is taken
   *        directly from item.
   * @param sExtId Corresponds to {@link InternalSite.externalId}.
   * @param sId Corresponds to {@link InternalSite.id}.
   * @param sName: Corresponds to {@link InternalSite.name}.
   * @param pValidTo The end date at which sellout price should be ended. Cannot be after {@link this.pValidToFPrice}. Value of the field
   *        is uploaded by user but user can still edit this field later on. Value cannot be in the past. It is important to validate this
   *        value against the value of price of origin item.
   * @param pValidToFPrice The end date at which sellout price currently ends. Taken from {@link FinalProductPrice.validTo}. It is
   *        important to note that the source value is not 100 % sufficient, as it does not cover the entire history of exported prices
   *        associated with the item.
   * @param fPrice Corresponds to presentable value of {@link FinalProductPrice price} of associated item.
   * @param pValidFromFPrice Should represent the last exported value of price validity start.
   *        See {@link FinalProductPrice.lastExportedValidFrom}. It is important to note that the source value is not 100 % sufficient, as
   *        it does not cover the entire history of exported prices associated with the item.
   * @param exportedPriceHistory Contains all valid prices exported from the release item.
   *        See {@link SelloutReleaseItemPrices.exportedPriceHistory}.
   * @param readonly Declares whether record is editable. If not, true is set, false otherwise. If value is set to true, no attribute can
   *        be no longer edited (nor within BE or by user).
   * @param terminate The flag which determines whether price should be terminated. Default value of all items is set to true, if there
   *        is no validation error related to this item during creating of item.
   * @param validation The wrapper of all (user) related alerts, which resulted from validations.
   */
  function SelloutTerminationItem(id, terminationId, rId, rName, pListType, workflowType, iId, pExtId, pId, pName, sExtId, sId, sName, pValidTo, pValidToFPrice, fPrice, pValidFromFPrice, exportedPriceHistory, readonly, terminate, validation) {
    var _this;

    _classCallCheck(this, SelloutTerminationItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationItem).call(this));
    _this.id = id;
    _this.terminationId = terminationId;
    _this.rId = rId;
    _this.rName = rName;
    _this.pListType = pListType;
    _this.workflowType = workflowType;
    _this.iId = iId;
    _this.pExtId = pExtId;
    _this.pId = pId;
    _this.pName = pName;
    _this.sExtId = sExtId;
    _this.sId = sId;
    _this.sName = sName;
    _this.pValidTo = pValidTo;
    _this.pValidToFPrice = pValidToFPrice;
    _this.fPrice = fPrice;
    _this.pValidFromFPrice = pValidFromFPrice;
    _this.exportedPriceHistory = exportedPriceHistory;
    _this.readonly = readonly;
    _this.terminate = terminate;
    _this.validation = validation;
    return _this;
  }

  return SelloutTerminationItem;
}(DomainObject_1.DomainObject);

exports.SelloutTerminationItem = SelloutTerminationItem;

SelloutTerminationItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTerminationItem.name);
  return {
    id: builder.id('id'),
    terminationId: builder.str('terminationId'),
    rId: builder.opt(builder.str('rId')),
    rName: builder.opt(builder.str('rName')),
    pListType: builder.opt(builder.str('pListType')),
    workflowType: builder.opt(builder.str('workflowType')),
    iId: builder.opt(builder.str('iId')),
    pExtId: builder.str('pExtId'),
    pId: builder.str('pId'),
    pName: builder.str('pName'),
    sExtId: builder.str('sExtId'),
    sId: builder.str('sId'),
    sName: builder.str('sName'),
    pValidTo: builder.date('pValidTo'),
    pValidToFPrice: builder.opt(builder.date('pValidToFPrice')),
    fPrice: builder.opt(builder.bigNum('fPrice')),
    pValidFromFPrice: builder.opt(builder.date('pValidFromFPrice')),
    exportedPriceHistory: builder.opt(builder.obj('exportedPriceHistory', ExportedPriceHistory_1.ExportedPriceHistory.schema, function (mat) {
      return ExportedPriceHistory_1.ExportedPriceHistory.fromDataDict(mat);
    })),
    readonly: builder.bool('readonly'),
    terminate: builder.bool('terminate'),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();